<template>
  <div class="sfsdrrwer">
    <!-- <p class="sdfsdtye"></p> -->
    <div class="pr">
      <img src="@/assets/img/banner.jpg" class="banner w100" />
      <div class="kjnmxer1">
        <div class="bgff yj4 sgfyyw pd pm20">
          <!-- <p class="cen pt20">
            <img src="../assets/img/yyxz.png" class="cz fsgdywe" />
          </p> -->
          <p class="cen pt20">
              <span class="fz20 z3 pr jjnndsrtywe">请选择参观区域</span>
          </p>
          <div class="mt15" @click="toHome1('5,6,7')">
            <p class="cen ">
              <img src="../assets/img/5.png" class="cz fsgdywe" />
            </p>
            <div class="jjseerrt1">海战博物馆及威远炮台</div>
          </div>
          <div class="pt20" @click="toHome1('3')">
            <p class="cen">
              <img src="../assets/img/3.png" class="cz fsgdywe" />              
            </p>
            <div class="jjseerrt1">虎门林则徐纪念馆</div>
          </div>
          <div class="mt15" @click="toHome1('4')">
            <p class="cen ">
              <img src="../assets/img/4.png" class="cz fsgdywe" />
            </p>
            <div class="jjseerrt1">沙角炮台</div>
          </div>
          
        </div>
        
      </div>
      
    </div>
    
    <van-dialog v-model="showNews" :showConfirmButton="false">
      <div class="pt10 pm10 pr cen cf" style="background-color: #A9716D;">
        <span class="cz ml10 fz17">公 告</span>   
        <!-- <van-icon
          name="cross"
          size="20px"
          style="position: absolute; right: 0px; top: 2px"
          class="pt10 pm10 pl10 pr10"
          @click="showNews = false"
        /> -->
      </div>
      <div class="newDiv">
        <!-- <news-info :id="autoPushNewsId"></news-info> -->
        <div class="content">
          <div v-if="autoPushNews.content" v-html="autoPushNews.content"></div>
        </div>
      </div>
      <div class=" pt10 pm10 btm cen"> 
        <van-button type="primary" class="w80"  @click="showNews = false" >已知晓</van-button>
      </div>
      
    </van-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import settingService from "./../services/settingService.js";
import scenicService from "./../services/scenicService.js";
import tokenService from "@/services/tokenService.js";
import ticketTypeService from "./../services/ticketTypeService.js";

export default {
  name: "home",
  data() {
    return {
      clientWidth: 375,
      clientHeight: 667,
      checked: false,
      active: 0,
      daosji: 0,
      jjnjsd: 0,
      disabled: true,
      showDaojis: false,
      groupOrderFlag :false,
      ticketTypeIds:[],
      showNews: false,
      autoPushNews: {},
    };
  },
  computed: {
    contentWidth() {
      return this.clientWidth - 60;
    },
    contentHeight() {
      return this.clientHeight - 200;
    },
    ...mapState({
      member: (state) => state.memberModule.member,
      notice: (state) => state.homeModule.notice,
    }),
  },
  methods: {
    async toHome1(ticketTypeIds) {
      let token = tokenService.getToken();
      if(token && token.access_token_type=="GDHRSS"){
        //广东省社会保障卡居民服务“一卡通”应用平台
        //直接转至散客下单界面
        var groundIds="";
        var groundNames = window.groundNames;
        if(!groundNames){
          groundNames = {"海战博物馆及威远炮台":"2,4,5","虎门林则徐纪念馆":"1","沙角炮台":"3"};
        }
        switch(ticketTypeIds){
          case "5,6,7": //海战博物馆及威远炮台
              groundIds= groundNames["海战博物馆及威远炮台"];
              break;
          case "3": //虎门林则徐纪念馆
              groundIds= groundNames["虎门林则徐纪念馆"];
              break;
          case "4": //沙角炮台
              groundIds= groundNames["沙角炮台"];
              break;
          default:
              groundIds= this.groundName;
        }
        this.ticketTypeIds = await ticketTypeService.getTicketTypeIdsByGroundIds(groundIds);
        this.$router.push({
          name: "createorder",
          params: { addChildren: true , ticketTypeIds: this.ticketTypeIds},
        });
      }
      else{
        this.ticketTypeIds=ticketTypeIds;
        this.$router.push({
          name: "home1",
          params: { groundName: this.ticketTypeIds },
        });
      }
    },
    createOrder(addChildren) {
      if(this.ticketTypeIds)
      {
        this.$router.push({
          name: "createorder",
          query: { addChildren: addChildren, ticketTypeIds: this.ticketTypeIds },
        });
      }
    },
    createGroupOrder() {
      if (this.member.isCustomerLogin) {
        //this.$router.push("/creategrouporder");
        this.$router.push({
          name: "creategrouporder",
          query: { ticketTypeIds: this.ticketTypeIds },
        });
      } else {
        this.$router.push({
          name: "grouplogin",
          params: { shouldBind: "0", nextPath: "creategrouporder",ticketTypeIds: this.ticketTypeIds },
        });
      }
    },
    resize() {
      this.clientWidth = document.documentElement.clientWidth;
      this.clientHeight = document.documentElement.clientHeight;
    },
    ...mapMutations([
      "setTitle",
      "showNavbar",
      "setShowNavbarLeft",
      "setShowNavbarRight",
    ]),
    ...mapActions("homeModule", [appConsts.loadOrderNoticeAsync]),
    ...mapActions("memberModule", [appConsts.loadMemberAsync]),
  },
  async created() {
    this.autoPushNews ={};
    var newses = await scenicService.getNewsThemesAsync();
    if(newses && newses.length>0) {
      var autoPushNews = newses.find((o) => {
        return o.autoPushFlag == true;
      });
      if (autoPushNews) {
        autoPushNews.content = decodeURIComponent(autoPushNews.content);
        this.autoPushNews = autoPushNews;
        this.showNews = true;
      }
    }
    //await this.loadOrderNoticeAsync();
    this.ticketTypeIds=[];
    await this.loadMemberAsync();
    const options = await settingService.getOptionsAsync();
      if (options && options.GroupOrderFlag && options.GroupOrderFlag=="1") {
        
        this.groupOrderFlag=true;
      }

    this.setTitle(this.notice.scenicName);   
    if(this.showDaojis)
    {      
      let sdd = setInterval(() => {
        if (this.daosji-- <= 1) {
          clearTimeout(sdd);
          this.disabled=false;
        }
      }, 1000);
    }
  },
  async mounted() {
    this.resize();
    let vm = this;
    window.onresize = function () {
      vm.resize();
    };
    await this.loadOrderNoticeAsync();
    this.daosji=Number(this.notice.readTime);
    if(this.daosji>=0)
    {
      this.showDaojis=true;
    }
    // this.daosji=Number(this.notice.readTime);
    // let sdd = setInterval(() => {
    //   if (this.daosji-- <= 1) {
    //     clearTimeout(sdd);
    //   }
    // }, 1000);
    var u = navigator.userAgent;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isIOS) {
      this.jjnjsd = window.screen.height - 400;
    } else {
      this.jjnjsd = window.screen.height - 360;
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {      
      if (from.name == "login") {
        vm.setShowNavbarLeft(false);
      }
      vm.setShowNavbarRight(false);
    });
  },
  beforeDestroy() {
    this.setShowNavbarLeft(true);
    this.setShowNavbarRight(true);
    window.onresize = null;
  },
};
</script>

<style scoped>
.sgfyyw {
  height: 100%;
}

.sdfsdtye {
  position: fixed;
  left: 0;
  top: 46;
  width: 100%;
  height: 100%;

  /* background: url("../assets/img/indexbg.jpg") no-repeat;
  background-color: #f3efd9;
  background-size: 100%; */
}

.sfsdrrwer {
  bottom: 50px;
  height: calc(100vh - 50px);
  background: url("../assets/img/indexbg.jpg") no-repeat;
  background-color: #f3efd9;
  background-size: 100%;
  background-position: bottom;
}
.kjnmxer1 {
  z-index: 1000;
  position: fixed;
  left: 0;
  right: 0;
  margin-left: 10px;
  margin-right: 10px;
  /* width: 100%; */
  /* height: 60vh; */
  height: calc(100vh - 160px);
  top: 100px;
}
.kjnmxer2 {
  z-index: 1000;
  position: fixed;
  left: 0;
  right: 0;
  margin-left: 10px;
  margin-right: 10px;
  /* width: 100%; */
  /* height: 60vh; */
  height: calc(100vh - 250px);
  top: 100px;
}
.sdfsdttyw2 {
  position: fixed;
  left: 0;
  bottom: 60px;
  width: 100%;
  padding-left: 15px;
  padding-right: 15px;
  height: 155px;
}
.fsgdywe {
  width: 100%;
}

.jhbnxertr {
  background: #a9716d;
  display: inline-block;
  width: 91px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-top-right-radius: 10px;
}
.jjseerrt {
  line-height: 18px;
}

.jjseerrt1 {
    text-align: center;
    /* position: absolute; */
    /* background-color: rgba(0,0,0,.5); */
    /* margin-top: -24px; */
    /* color: #fff; */
    line-height: 24px;
    width: calc(100vw - 40px);
    border-radius: 0 0 5px 5px;
    font-size: 14px;
}

.jjnnxeer {
  height: 48px;
  padding-top: 12px;
  padding-left: 10px;
  background: #53211d;
}

.jjhhjsa {
  width: 26px;
  height: 26px;
  background-position: -11px -23px;
}

.jjhhjsa.ab {
  width: 32px;
  background-position: -61px -23px;
}

.jjhhjsa.ac {
  width: 30px;
  background-position: -124px -23px;
}

.dfgdfy6 {
  line-height: 1.4;
  position: relative;
  top: -4px;
}
.dsfstywer {
  opacity: 0.7;
  text-align: center;
}
.sdrtter {
  pointer-events: none;
  opacity: 0.4;
}

.bannerDiv {
  height: 125px;
  width: 100%;
  background: url(../assets/img/banner.jpg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.buttonImg {
  width: 90px;
  height: 44px;
}
.content {
  margin-top: 10px;
  padding: 0 10px;
  padding-bottom: 10px;
  background-color: white;
  /* min-height: calc(100vh - 10px); */
}
.newDiv {
  max-height: calc(50vh);
  overflow-y: auto;
}
</style>
